import React from 'react';
import PromptTextarea from 'src/components/PromptTextarea';
import { Space } from 'antd';
import useAgentSettings from '../Tabs/hook';

export default function MasterIntent() {
  const {
    isLoading,
    originalSettings,
    settings,
    updateAgentSettings,
    saveAgentSettings,
    isUpdating
  } = useAgentSettings();

  return (
    <PromptTextarea
      title={
        <Space>
          <span role="img" aria-label="star">
            ⭐
          </span>
          Master intent
        </Space>
      }
      isCollapsable
      enabled={settings.defaultTriageEnabled}
      prompt={settings.defaultTriageInstructions}
      onSave={saveAgentSettings}
      onReset={() => {
        updateAgentSettings({
          defaultTriageInstructions: originalSettings.defaultTriageInstructionsDefault
        });
      }}
      onCancel={() => updateAgentSettings(originalSettings)}
      onToggle={() => {
        updateAgentSettings({
          defaultTriageEnabled: !settings.defaultTriageEnabled
        });
      }}
      onPromptChange={e => {
        const { value } = e.target;
        updateAgentSettings({
          defaultTriageInstructions: value
        });
      }}
      isLoading={isLoading}
      isSaving={isUpdating}
    />
  );
}
